import e from "../../utils/classNames.js";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/divider/Divider.tsx
var i = (i) => {
	let { spacing: a = 15, dividerWidth: o = 1, dividerColor: s = "light", asSpacer: c = !1, vertical: l = !1, titleAlignment: u = "center", className: d = "", children: f } = i, p = e("Divider", "position-relative", !l && "width-100pct", d), m = `${a}px`, h = {};
	l && (h.paddingLeft = m, h.paddingRight = m), l || (h.paddingTop = m, h.paddingBottom = m);
	let g = e("divider-line", `bg-${s}`), _ = typeof f == "string", v = /* @__PURE__ */ n("div", {
		className: g,
		style: {
			width: l ? `${o}px` : "100%",
			height: l ? "100%" : `${o}px`
		}
	}), y = /* @__PURE__ */ n("div", {
		className: "flex-1-0",
		children: v
	}), b = /* @__PURE__ */ n("div", {
		className: _ ? "padding-x-10" : "",
		children: f
	}), x = e("divider-title", "display-flex", "align-items-center");
	return /* @__PURE__ */ r("div", {
		className: p,
		style: h,
		children: [!c && !f && v, f && /* @__PURE__ */ r("div", {
			className: x,
			children: [
				u === "left" && /* @__PURE__ */ r(t, { children: [b, y] }),
				u === "center" && /* @__PURE__ */ r(t, { children: [
					y,
					b,
					y
				] }),
				u === "right" && /* @__PURE__ */ r(t, { children: [y, b] })
			]
		})]
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=Divider.js.map